const Footer = ({ children }) => {
  return <div 
  style={{
    color:'black'
  }}
  className="main-footer">{children}</div>;
};

export default Footer;
